import classNames from "classnames";
import React, { memo, useMemo } from "react";
function MenuToggler(props) {
    const containerStyle = useMemo(() => props.size
        ? {
            width: `${props.size}px`,
            height: `${props.size}px`,
            maxWidth: `${props.size}px`,
            maxHeight: `${props.size}px`
        }
        : {}, [props.size]);
    return (React.createElement("div", { role: "none", style: containerStyle, onClick: props.onClick, className: classNames(props.className, "d-flex justify-content-center v-center-items line-height-1", props.onClick && "clickable"), id: props.id }, props.children));
}
export default memo(MenuToggler);
